import { useState } from "react";
import { Field, Input, Button } from "@chakra-ui/react";
import { CustomDialog } from "../../../shared/views/CustomDialog";

const formId = "transferUserReferences";

export const TransferUserReferencesModal = ({
  onSubmit,
  onClose,
}: {
  onSubmit: (targetEmail: string) => Promise<void>;
  onClose: () => void;
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [targetEmail, setTargetEmail] = useState("");

  return (
    <CustomDialog
      onClose={onClose}
      header={"Transfer user references"}
      footer={
        <Button
          loading={submitting}
          colorPalette={"primary"}
          type="submit"
          form={formId}
        >
          Confirm
        </Button>
      }
    >
      <form
        id={formId}
        onSubmit={async (e) => {
          e.preventDefault();
          setSubmitting(true);
          await onSubmit(targetEmail.trim());
          setSubmitting(false);
        }}
      >
        <Field.Root>
          <Field.Label>Target user email</Field.Label>
          <Input
            required
            name="name"
            onChange={(e) => setTargetEmail(e.target.value)}
            value={targetEmail}
            autoFocus
          />
        </Field.Root>
      </form>
    </CustomDialog>
  );
};
